<template>
  <div>
    <Hero></Hero>
    <SchemaDrift></SchemaDrift>
    <AwsGlue></AwsGlue>
    <Testimonial></Testimonial>
    <DestinationIntegrations></DestinationIntegrations>
<!--    <GettingStarted></GettingStarted>-->
<!--    <EnterpriseGrade></EnterpriseGrade>-->
    <FooterSignup></FooterSignup>



  </div>
</template>

<script>

import Hero from './sections/developer/Hero.vue'
import AwsGlue from './sections/developer/AwsGlue.vue'
import Testimonial from './sections/developer/Testimonial.vue'
import DestinationIntegrations from './sections/developer/DestinationIntegrations.vue'
import SchemaDrift from './sections/developer/SchemaDrift.vue'
// import GettingStarted from "@/components/sections/developer/GettingStarted.vue";
// import EnterpriseGrade from "@/components/sections/developer/EnterpriseGrade.vue";
import FooterSignup from './sections/developer/FooterSignup.vue'

export default {
  name: 'Home',
  components: {
    Hero,
    AwsGlue,
    Testimonial,
    DestinationIntegrations,
    SchemaDrift,
    FooterSignup
    // GettingStarted,
    // EnterpriseGrade,
  },
  props: {
    msg: String
  },
  head: {
    title: {
      inner: 'Skippr',
      separator: '-',
      complement: 'Developers'
    },
    //omited
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
